import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import '../css/Announcements.css';

const API_URL = process.env.REACT_APP_BACKEND_URL;

function AnnouncementPopup() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [popups, setPopups] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const dismissed = JSON.parse(localStorage.getItem('dismissedPopups') || '{}');
        const today = new Date().toISOString().slice(0, 10);

        // 만료된 dismiss 항목 정리
        Object.keys(dismissed).forEach(key => {
            if (dismissed[key] !== today) delete dismissed[key];
        });
        localStorage.setItem('dismissedPopups', JSON.stringify(dismissed));

        const fetchPopups = async () => {
            try {
                const res = await fetch(`${API_URL}/api/v1/announcements/popups`);
                const data = await res.json();
                if (data.success && data.popups.length > 0) {
                    const visible = data.popups.filter(p => !dismissed[p.announcement_id]);
                    setPopups(visible);
                }
            } catch (e) { console.error(e); }
        };
        fetchPopups();
    }, []);

    const handleDismissToday = (id) => {
        const dismissed = JSON.parse(localStorage.getItem('dismissedPopups') || '{}');
        const today = new Date().toISOString().slice(0, 10);
        dismissed[id] = today;
        localStorage.setItem('dismissedPopups', JSON.stringify(dismissed));
        const next = popups.filter(p => p.announcement_id !== id);
        setPopups(next);
        setCurrentIndex(0);
    };

    const handleClose = (id) => {
        const next = popups.filter(p => p.announcement_id !== id);
        setPopups(next);
        setCurrentIndex(0);
    };

    const handleViewDetail = (id) => {
        handleClose(id);
        navigate('/announcements');
    };

    if (popups.length === 0) return null;

    const popup = popups[currentIndex] || popups[0];
    if (!popup) return null;

    return (
        <div className="ann-popup-overlay" onClick={() => handleClose(popup.announcement_id)}>
            <div className="ann-popup-container" onClick={e => e.stopPropagation()}>
                <button className="ann-popup-close" onClick={() => handleClose(popup.announcement_id)}>
                    {'\u2715'}
                </button>

                {popups.length > 1 && (
                    <div className="ann-popup-counter">
                        {currentIndex + 1} / {popups.length}
                    </div>
                )}

                <div className="ann-popup-body">
                    <h3 className="ann-popup-title">{popup.title}</h3>

                    {popup.popup_image_url && (
                        <div className="ann-popup-image">
                            <img src={`${API_URL}${popup.popup_image_url}`} alt={popup.title} />
                        </div>
                    )}

                    {popup.popup_text && (
                        <div className="ann-popup-text">
                            {popup.popup_text.split('\n').map((line, i) => (
                                <p key={i}>{line || '\u00A0'}</p>
                            ))}
                        </div>
                    )}
                </div>

                <div className="ann-popup-footer">
                    <button className="ann-popup-dismiss" onClick={() => handleDismissToday(popup.announcement_id)}>
                        {t('announcement.popup.dismissToday')}
                    </button>
                    <div className="ann-popup-footer-right">
                        {popup.content && (
                            <button className="ann-popup-detail" onClick={() => handleViewDetail(popup.announcement_id)}>
                                {t('announcement.popup.viewDetail')}
                            </button>
                        )}
                        {popups.length > 1 && currentIndex < popups.length - 1 && (
                            <button className="ann-popup-next" onClick={() => setCurrentIndex(prev => prev + 1)}>
                                {t('announcement.popup.next')}
                            </button>
                        )}
                        <button className="ann-popup-close-btn" onClick={() => handleClose(popup.announcement_id)}>
                            {t('announcement.popup.close')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AnnouncementPopup;
